"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BD4_USER_ID_KEY = exports.LANGUAGE_COOKIE_KEY = exports.PARTNER_REFERENCE = exports.B2B_MARKUP_KEY = exports.AGENCY_KEY = exports.PARTNER_KEY = void 0;
exports.PARTNER_KEY = 'partner';
exports.AGENCY_KEY = 'agency';
exports.B2B_MARKUP_KEY = 'b2bMarkup';
exports.PARTNER_REFERENCE = 'partner_reference';
exports.LANGUAGE_COOKIE_KEY = 'NEXT_LOCALE';
exports.BD4_USER_ID_KEY = 'bd4ti';
//# sourceMappingURL=RequestContext.constants.js.map